export default __webpack_public_path__ + "static/media/golden-arches.ade3ca28.png";